(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-70109-connected"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vr-connected-product')) {
  class ConnectedProduct extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      const dataNode = this.querySelector('[data-product-data]');
      const template = this.querySelector('[data-product-template]');
      if (!dataNode || !template) return;
      const data = JSON.parse(dataNode.textContent);
      const root = this.attachShadow({mode:'open'});
      root.appendChild(template.content.cloneNode(true));
      const variants = data.variants.map(variant => {
        const match = variant.options[0].match(/^70109-([0-9.]+)\s*\/\s*(.+)$/);
        return {...variant, weight: match ? match[1] : variant.options[0], color: match ? match[2].trim() : ''};
      });
      const $ = selector => root.querySelector(selector);
      const requestedId = new URL(location.href).searchParams.get('variant');
      let selected = variants.find(v => String(v.id) === requestedId) || variants.find(v => v.id === data.selectedId) || variants[0];
      const group = (key, label, values) => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'floral-option-group';
        const legend = document.createElement('legend'); legend.textContent = label; fieldset.appendChild(legend);
        const options = document.createElement('div'); options.className = key === 'color' ? 'reference-swatches' : 'floral-options';
        for (const value of values) {
          const button = document.createElement('button'); button.type = 'button'; button.dataset.option = key; button.dataset.value = value;
          button.setAttribute('aria-label', key === 'weight' ? value + 'ct' : value);
          if (key === 'color') {
            button.className = 'color-option';
            const swatch = document.createElement('span'); swatch.className = 'swatch ' + value.toLowerCase(); swatch.setAttribute('aria-hidden', 'true'); swatch.appendChild(document.createElement('i')); button.appendChild(swatch);
            button.title = value;
          } else { button.className = 'floral-choice-label'; button.textContent = value + 'ct'; }
          options.appendChild(button);
        }
        fieldset.appendChild(options); return fieldset;
      };
      $('[data-options]').append(group('weight', data.weightLabel, [...new Set(variants.map(v => v.weight))]), group('color', data.colorLabel, [...new Set(variants.map(v => v.color))]));
      const choose = (variant, updateUrl = true) => {
        if (!variant) return;
        selected = variant; this.dataset.variantId = String(variant.id);
        $('[data-price]').textContent = variant.money;
        $('[data-sku]').textContent = variant.sku;
        $('[data-variant-input]').value = String(variant.id);
        for (const button of root.querySelectorAll('[data-option]')) {
          const key = button.dataset.option;
          const matches = variants.some(v => v[key] === button.dataset.value && v[key === 'weight' ? 'color' : 'weight'] === variant[key === 'weight' ? 'color' : 'weight']);
          button.disabled = !matches;
          button.setAttribute('aria-pressed', String(button.dataset.value === variant[key]));
        }
        const mediaId = String(variant.mediaId || root.querySelector('[data-media-id]')?.dataset.mediaId || '');
        root.querySelectorAll('[data-media-id]').forEach(el => { el.hidden = el.dataset.mediaId !== mediaId; });
        root.querySelectorAll('[data-thumb-id]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.thumbId === mediaId)));
        if (updateUrl) {const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState(null, '', url);}
      };
      root.addEventListener('click', event => {
        const option = event.target.closest('[data-option]');
        if (option) {
          const key = option.dataset.option;
          choose(variants.find(v => v[key] === option.dataset.value && v[key === 'weight' ? 'color' : 'weight'] === selected[key === 'weight' ? 'color' : 'weight']));
        }
        const thumb = event.target.closest('[data-thumb-id]');
        if (thumb) choose(variants.find(v => String(v.mediaId) === thumb.dataset.thumbId && v.weight === selected.weight) || variants.find(v => String(v.mediaId) === thumb.dataset.thumbId));
        const photo = event.target.closest('[data-media-id]');
        if (photo) { const img = photo.querySelector('img'); $('[data-zoom-image]').src = img.currentSrc || img.src; $('[data-zoom-image]').alt = img.alt; $('[data-lightbox-title]').textContent = selected.title; $('[data-lightbox]').showModal(); }
        if (event.target.closest('[data-close]') || event.target === $('[data-lightbox]')) $('[data-lightbox]').close();
      });
      this.onPopState = () => {const id = new URL(location.href).searchParams.get('variant'); choose(variants.find(v => String(v.id) === id) || variants[0], false);};
      window.addEventListener('popstate', this.onPopState);
      choose(selected, false);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPopState); }
  }
  customElements.define('vr-connected-product', ConnectedProduct);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('vr-campaign-hero')) return;

    class VRCampaignHero extends HTMLElement {
      connectedCallback() {
        this.mount();
      }

      disconnectedCallback() {
        this.unmount();
      }

      mount() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('[data-video-toggle]');
        this.label = this.querySelector('[data-toggle-label]');
        this.status = this.querySelector('[data-video-status]');
        if (!this.video || !this.button || !this.label || !this.status) return;
        this.controller = new AbortController();
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.playing = false;
        this.pending = false;
        this.failed = false;
        this.userPaused = false;
        this.manualPlayback = false;
        this.activeUrl = '';
        this.playVersion = 0;
        this.video.muted = true;
        this.video.defaultMuted = true;
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => this.toggle(), options);
        this.video.addEventListener('playing', () => {
          if (!this.canPlay()) {
            this.pause();
            return;
          }
          this.pending = false;
          this.playing = true;
          this.failed = false;
          this.classList.add('is-video-ready');
          this.updateControls();
        }, options);
        this.video.addEventListener('pause', () => {
          this.playing = false;
          this.updateControls();
        }, options);
        this.video.addEventListener('error', () => {
          if (this.activeUrl) this.fail();
        }, options);
        this.mobile.addEventListener('change', () => {
          this.releaseSource();
          this.sync();
        }, options);
        this.motion.addEventListener('change', () => {
          this.manualPlayback = false;
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target !== this) continue;
            this.visible = entry.isIntersecting && entry.intersectionRatio > 0.05;
            this.sync();
          }
        }, { threshold: [0, 0.05, 0.2] });
        this.observer.observe(this);
        this.updateControls();
      }

      selectedUrl() {
        const value = (this.mobile.matches ? this.dataset.mobileVideo : this.dataset.desktopVideo) || '';
        if (!value.trim()) return '';
        try {
          const url = new URL(value.trim(), document.baseURI);
          return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
        } catch {
          return '';
        }
      }

      canPlay() {
        return Boolean(this.controller && this.selectedUrl() && this.visible && !document.hidden && !this.userPaused && !this.failed && (!this.motion.matches || this.manualPlayback) && (this.dataset.autoplay === 'true' || this.manualPlayback));
      }

      sync() {
        if (!this.controller) return;
        if (this.canPlay()) this.start();
        else this.pause();
        this.updateControls();
      }

      start() {
        if (!this.canPlay() || this.pending || this.playing) return;
        const url = this.selectedUrl();
        if (url !== this.activeUrl) {
          this.releaseSource();
          this.activeUrl = url;
          this.video.src = url;
          this.video.load();
        }
        this.pending = true;
        const version = ++this.playVersion;
        const controller = this.controller;
        this.updateControls();
        let request;
        try {
          request = this.video.play();
        } catch {
          this.fail();
          return;
        }
        Promise.resolve(request).then(() => {
          if (this.controller !== controller || version !== this.playVersion) return;
          this.pending = false;
          this.updateControls();
        }).catch(error => {
          if (this.controller !== controller || version !== this.playVersion) return;
          this.pending = false;
          if (error.name !== 'AbortError') this.fail();
          else this.updateControls();
        });
      }

      pause() {
        if (!this.video) return;
        this.playVersion += 1;
        this.pending = false;
        this.video.pause();
        this.playing = false;
        this.updateControls();
      }

      toggle() {
        if (this.playing || this.pending) {
          this.userPaused = true;
          this.pause();
          return;
        }
        if (this.failed) this.releaseSource();
        this.failed = false;
        this.userPaused = false;
        this.manualPlayback = true;
        this.sync();
      }

      fail() {
        this.failed = true;
        this.pause();
        this.classList.remove('is-video-ready');
        this.updateControls();
      }

      releaseSource() {
        this.pause();
        this.activeUrl = '';
        this.failed = false;
        this.classList.remove('is-video-ready');
        this.video.removeAttribute('src');
        this.video.load();
      }

      updateControls() {
        if (!this.button || !this.controller) return;
        const available = Boolean(this.selectedUrl());
        const action = this.failed ? 'retry' : (this.playing || this.pending ? 'pause' : 'play');
        const label = this.dataset[`${action}Label`] || '';
        this.button.hidden = !available;
        this.label.textContent = label;
        this.button.setAttribute('aria-label', label);
        this.dataset.action = action;
        this.dataset.playbackState = this.failed ? 'failed' : this.playing ? 'playing' : this.pending ? 'loading' : 'paused';
        this.classList.toggle('is-video-error', this.failed);
        const message = !available ? '' : this.failed ? this.dataset.errorMessage : this.playing ? this.dataset.playingMessage : this.pending ? this.dataset.loadingMessage : this.dataset.pausedMessage;
        if (this.status.textContent !== (message || '')) this.status.textContent = message || '';
      }

      unmount() {
        if (!this.controller) return;
        this.controller.abort();
        this.observer.disconnect();
        this.releaseSource();
        this.controller = null;
        this.button.hidden = true;
      }
    }

    customElements.define('vr-campaign-hero', VRCampaignHero);
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('vr-campaign-hero').forEach(hero => hero.mount());
    });
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('vr-campaign-hero').forEach(hero => hero.unmount());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-custom-service"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vrc-custom').forEach(root=>{
  const trigger=root.querySelector('[data-vrc-enlarge]'),dialog=root.querySelector('.vrc-story-dialog');
  if(!trigger||!dialog)return;
  trigger.addEventListener('click',()=>dialog.showModal());
  dialog.querySelector('[data-vrc-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>trigger.focus());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-header"]) return;
  try {
    
document.addEventListener('click',function(event){
  document.querySelectorAll('.vr-nav-group[open],.vr-mobile-menu[open]').forEach(function(menu){if(!menu.contains(event.target)){menu.open=false;}});
});
document.addEventListener('toggle',function(event){
  if(event.target.matches('.vr-nav-group')&&event.target.open){
    const nav=event.target.parentElement;
    nav.querySelectorAll('.vr-nav-group[open]').forEach(function(menu){if(menu!==event.target){menu.open=false;}});
  }
},true);
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.vr-nav-group[open],.vr-mobile-menu[open]').forEach(function(menu){menu.open=false;});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-ring-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const targetId = 'ringbuilder-engagement-ge';
  const host = document.getElementById(targetId);
  if (!host || host.dataset.vrInitialized) return;
  host.dataset.vrInitialized = 'true';
  const observedSettingRoots = new WeakSet();
  const syncHiddenSettingRows = () => {
    document.querySelectorAll('#ringbuilder-engagement-ge, #ring-builder-fixed-overlay-host').forEach(container => {
      const root = container.shadowRoot || container;
      if (!observedSettingRoots.has(root)) {
        observedSettingRoots.add(root);
        settingDetailsObserver.observe(root, { childList: true, subtree: true, characterData: true });
      }
      if (container.shadowRoot && !root.querySelector('[data-vr-rhodium-style]')) {
        const style = document.createElement('style');
        style.setAttribute('data-vr-rhodium-style', '');
        style.textContent = 'tr[data-vr-hidden-rhodium]{display:none!important}';
        root.appendChild(style);
      }
      root.querySelectorAll('tr').forEach(row => {
        const label = row.cells[0]?.textContent.replace(/\s+/g, ' ').trim().replace(/\s*:\s*$/, '');
        row.toggleAttribute('data-vr-hidden-rhodium', label === 'Rhodium Plated');
      });
    });
  };
  const settingDetailsObserver = new MutationObserver(syncHiddenSettingRows);
  settingDetailsObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  syncHiddenSettingRows();
  // Shadow roots can be attached after their host is inserted into the page.
  window.setInterval(syncHiddenSettingRows, 1000);

  document.title = host.closest('[data-ring-page-title]').dataset.ringPageTitle;
  const loading = document.querySelector('[data-ring-loading]');
  const error = document.querySelector('[data-ring-error]');
  const root = '/apps/gemtheon-ring-builder/api/ring-builder';
  window.cdnPluginTargetId = targetId;
  window.cdnPluginType = 'subscription';
  window.ringbuilderGeApiSettings = {
    root,
    mediaPublicUrl: root + '/media/public',
    publicShareBaseUrl: root + '/social-share',
    previewMode: true
  };
  let ready = false;
  let uiConfig;
  const theme = {
    primaryColor: '#1e1b18', secondaryColor: '#493f32', accentColor: '#9a7a3f',
    surfaceColor: '#f7f3ea', colorMode: 'solid', buttonStyle: 'sharp',
    primaryFont: 'Arial', headerFont: 'Georgia', bodyFont: 'Arial', displayFont: 'Georgia'
  };
  const applyPreviewStyle = () => {
    if (!ready) return;
    window.dispatchEvent(new CustomEvent('gemtheon:ring-builder-preview-update', {
      detail: { targetId, theme, ...(uiConfig ? { builderUiConfig: uiConfig } : {}) }
    }));
  };
  const fail = () => { if (!ready) { loading.hidden = true; error.hidden = false; } };
  const timer = window.setTimeout(fail, 30000);
  window.addEventListener('gemtheon:ring-builder-ready', event => {
    if (event.detail?.targetId !== targetId) return;
    ready = true;
    window.clearTimeout(timer);
    loading.hidden = true;
    error.hidden = true;
    applyPreviewStyle();
  });
  document.querySelector('[data-ring-reload]').addEventListener('click', () => window.location.reload());
  fetch(root + '/theme/ui-config', { credentials: 'same-origin', cache: 'no-store' })
    .then(response => { if (!response.ok) throw new Error('Configuration unavailable'); return response.json(); })
    .then(payload => {
      const config = payload.data?.config || payload.data || payload.config || payload;
      uiConfig = { ...config, benefits: { deliveryFallbackDays: 'Please contact us', items: [
        { id: 'free_insured_shipping', kind: 'preset', enabled: false, label: 'Shipping', icon: { type: 'library', key: 'shipping' } },
        { id: 'delivery', kind: 'preset', enabled: false, label: 'Delivery', icon: { type: 'library', key: 'delivery' } },
        { id: 'made_to_order', kind: 'preset', enabled: false, label: 'Made to order', icon: { type: 'library', key: 'made_to_order' } },
        { id: 'diamond_value_guarantee', kind: 'preset', enabled: false, label: 'Diamond guidance', icon: { type: 'library', key: 'guarantee' } }
      ] } };
      applyPreviewStyle();
    }).catch(() => {
      uiConfig = { benefits: { items: [{ id: 'guidance', kind: 'custom', enabled: true, label: 'Contact V Romance for personal guidance', icon: { type: 'library', key: 'diamond' } }] } };
      applyPreviewStyle();
    });
  fetch(root + '/version', { credentials: 'same-origin', cache: 'no-store' })
    .then(response => response.ok ? response.json() : null)
    .catch(() => null)
    .then(payload => {
      const version = typeof payload?.version === 'string' ? '?_rb_js_v=' + encodeURIComponent(payload.version) : '';
      const style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = '/apps/gemtheon-ring-builder/ring-builder/style.css' + version;
      document.head.appendChild(style);
      const script = document.createElement('script');
      script.type = 'module';
      script.src = '/apps/gemtheon-ring-builder/ring-builder/app.js' + version;
      script.onerror = fail;
      document.body.appendChild(script);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vrm-gem-sourcing"]) return;
  try {
    
const sourcingParams=new URLSearchParams(location.search);
const sourcingGem=document.getElementById('VRM-gemstone');
const sourcingReference=document.getElementById('VRMReference');
const requestedGem=sourcingParams.get('gemstone');
const requestedPiece=sourcingParams.get('piece');
if(sourcingGem && requestedGem && !sourcingGem.value){sourcingGem.value=requestedGem.slice(0,100);}
if(sourcingReference && requestedPiece){sourcingReference.value=requestedPiece.slice(0,300);sourcingReference.disabled=false;sourcingReference.closest('[data-sourcing-reference]').hidden=false;}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vrm-gemstones"]) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-vrm-enquire]');if(!link)return;const form=link.closest('.vrm-showcase').querySelector('[data-vrm-piece]');if(form){form.value=link.dataset.vrmEnquire;form.focus();}});
document.addEventListener('click',e=>{if(e.target.closest('[data-vrm-piece-link]')){try{sessionStorage.setItem('vrm-list',JSON.stringify({url:location.pathname+location.search+location.hash,y:scrollY,stone:document.querySelector('[data-vrm-stone]')?.value,type:document.querySelector('[data-vrm-type]')?.value}));}catch{}}});
const restoreVrmList=()=>{customElements.whenDefined('vrm-gallery').then(()=>{try{const s=JSON.parse(sessionStorage.getItem('vrm-list'));if(s&&s.url===location.pathname+location.search+location.hash){const gallery=document.querySelector('.vrm-showcase vrm-gallery');if(!gallery)return;const stone=gallery.querySelector('[data-vrm-stone]'),type=gallery.querySelector('[data-vrm-type]');if(stone&&s.stone)stone.value=s.stone;if(type&&s.type)type.value=s.type;gallery.dispatchEvent(new Event('change'));requestAnimationFrame(()=>scrollTo(0,s.y||0));}}catch{}});};
window.addEventListener('pageshow',restoreVrmList);
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',restoreVrmList,{once:true});}else{restoreVrmList();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vrm-layout-sample"]) return;
  try {
    
document.querySelectorAll('.vr-layout-sample').forEach(root=>{
  const gallery=root.querySelector('.vrl-gallery'),photos=[...root.querySelectorAll('[data-vrl-photo]')],dialog=root.querySelector('dialog'),full=root.querySelector('[data-vrl-full]');
  let active=0,slide=0,opener=null;
  const thumbs=[...root.querySelectorAll('[data-vrl-thumb]')];
  const syncThumbs=()=>thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===slide)));
  const modalShow=n=>{active=(n+photos.length)%photos.length;full.src=photos[active].href;};
  const move=n=>{slide=Math.max(0,Math.min(photos.length-1,n));syncThumbs();gallery.scrollTo({left:photos[slide].offsetLeft-photos[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  root.addEventListener('click',e=>{const thumb=e.target.closest('[data-vrl-thumb]'),photo=e.target.closest('[data-vrl-photo]'),modalStep=e.target.closest('[data-vrl-modal-step]');if(photo){e.preventDefault();opener=photo;modalShow(Number(photo.dataset.vrlPhoto));dialog.showModal();}const step=e.target.closest('[data-vrl-step]');if(step)move((slide+Number(step.dataset.vrlStep)+photos.length)%photos.length);if(thumb)move(Number(thumb.dataset.vrlThumb));if(modalStep)modalShow(active+Number(modalStep.dataset.vrlModalStep));if(e.target.closest('[data-vrl-close]'))dialog.close();});
  gallery.addEventListener('scroll',()=>{slide=Math.max(0,Math.min(photos.length-1,Math.round(gallery.scrollLeft/(gallery.clientWidth+12))));syncThumbs();},{passive:true});
  gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(slide+(e.key==='ArrowRight'?1:-1));}});
  dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();modalShow(active+(e.key==='ArrowRight'?1:-1));}});
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{if(opener)opener.focus();});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vrm-piece-page"]) return;
  try {
    
document.querySelectorAll('[data-gallery]').forEach(g=>{let current=0,x=null;const slides=[...g.querySelectorAll('[data-slide]')],buttons=[...g.querySelectorAll('[data-thumb]')];if(!slides.length||g.dataset.vrmReady)return;g.dataset.vrmReady='true';const stage=document.createElement('div');stage.className='vrm-photo-stage';slides[0].before(stage);slides.forEach(slide=>stage.appendChild(slide));const actions=g.querySelector('.vrm-gallery-actions');if(actions){actions.querySelector('[data-slide-count]')?.remove();actions.querySelectorAll('[data-step]').forEach(button=>{button.setAttribute('aria-label',button.textContent.trim());button.textContent=Number(button.dataset.step)<0?'‹':'›';});stage.appendChild(actions);}const show=n=>{current=(n+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==current);buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===current)));};g.addEventListener('click',e=>{const t=e.target.closest('[data-thumb]'),s=e.target.closest('[data-step]');if(t)show(Number(t.dataset.thumb));if(s)show(current+Number(s.dataset.step));});g.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));}});g.addEventListener('touchstart',e=>x=e.touches[0].clientX,{passive:true});g.addEventListener('touchend',e=>{if(x!==null){const d=e.changedTouches[0].clientX-x;if(Math.abs(d)>60)show(current+(d<0?1:-1));x=null;}},{passive:true});});
try{const s=JSON.parse(sessionStorage.getItem('vrm-list'));const back=document.querySelector('[data-list-back]');if(s&&back&&(s.url.startsWith('/collections/fine-gemstone-jewelry')||s.url.startsWith('/collections/fine-gemstone-jewelry?view=')))back.href=s.url;}catch{}

  } catch(e) { console.error(e); }
})();
})();
